var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-icon",class:_vm.classes,attrs:{"title":_vm.title},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('span',{staticClass:"tw-flex tw-items-center tw-justify-center"},[_c('svg-icon',{class:_vm.iconClasses,attrs:{"name":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }